import React from 'react';
import { Container, Box } from '@hover/blueprint';
import Header from './Header';
import PricingTable from './PricingTable';
import Footer from './Footer';

const ChooseThePlan: React.FC = () => (
  <Box bg="brandTan.100" alignItems="center" w="100%">
    <Container bg="brandTan.100" maxW="100%" centerContent px={0}>
      <Header />
      <PricingTable />
      <Footer />
    </Container>
  </Box>
);

export default ChooseThePlan;
